<script lang="ts">
import type { KbdKey } from 'composables/useKbd';
import type { Colors, Variants, Sizes } from 'types';

export interface KbdProps {
  /**
   * The element or component this component should render as.
   * @defaultValue 'kbd'
   */
  as?: any;
  value?: KbdKey | string;
  /**
   * What color to display
   * @defaultValue 'neutral'
   */
  color?: Colors;
  /**
   * What variant to display
   * @defaultValue 'soft'
   */
  variant?: Variants;
  /**
   * What size to display
   * @defaultValue 'md'
   */
  size?: Sizes;
  class?: string;
}

export interface KbdSlots {
  default(props?: {}): unknown;
}
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { Primitive } from 'reka-ui';
import { useKbd } from 'composables/useKbd';

const props = withDefaults(defineProps<KbdProps>(), {
  as: 'kbd',
  color: 'neutral',
  variant: 'outline',
  size: 'md'
});
defineSlots<KbdSlots>();

const { getKbdKey } = useKbd();

const classes = computed(() => [
  'e-kbd',
  props.color && `e-kbd-color-${props.color}`,
  props.variant && `e-kbd-variant-${props.variant}`,
  props.size && `e-kbd-size-${props.size}`
]);
</script>

<template>
  <primitive
    :as="as"
    :class="classes"
  >
    <slot>
      {{ getKbdKey(value) }}
    </slot>
  </primitive>
</template>
